import { Suspense } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { AppShell } from "../chrome/AppShell";
import { useAuth } from "@/lib/auth-context";
import { loginPathFor } from "@/lib/auth-return";

// Shared fallback shown while a lazily-loaded `(app)` page chunk is fetched
// (routes are code-split in `routes.tsx`). Mirrors the auth-loading style.
const pageFallback = (
  <div style={{ padding: 40, color: "var(--on-surface-variant)" }}>
    Se încarcă…
  </div>
);

// Phase 4c-i: combines the AppGuard auth check (same semantics as
// `src/shells/AppGuard.tsx`) with the protected-app chrome from
// `src/chrome/AppShell.tsx` and renders the matched child route via
// React Router's <Outlet />. The Next.js sibling `app/(app)/layout.tsx`
// composes these the same way: AppGuard > AppShell > children.
export function AppShellWithGuard() {
  const { user, loading } = useAuth();
  const { pathname, search } = useLocation();

  if (loading) {
    return (
      <div style={{ padding: 40, color: "var(--on-surface-variant)" }}>
        Se încarcă…
      </div>
    );
  }

  // Carry the page the visitor asked for (path + query) so sign-in lands back on it — a reminder
  // link from an email (`/notification/<id>`) opens that reminder once the user has signed in.
  if (!user) {
    return <Navigate to={loginPathFor(pathname + search)} replace />;
  }

  return (
    <AppShell>
      <Suspense fallback={pageFallback}>
        <Outlet />
      </Suspense>
    </AppShell>
  );
}
